import { TablePagination, Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let desc = '';
let entradaIn = '';
let salidaIn = '';
let filasTotales = 0;
const opcionesFilasPorPagina = [5, 10, 25];

class DatosMovimiento extends Component {
    constructor(props){
        super(props);
        this.state = {
            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------
            codigosMovimientos: [],
            numeroNombre: [],
            notificaciones: null,
            errores: null,
            movimientosFuncionario: [],
            consulta: false,
            consultaMarcaDia: false,
            consultaMediaHora: false,
            modalActualizar: false,
            modalBorrar: false,
            ingresoDias: true,
            ingresoMinutos: true,
            consultaReingreso: false,
            loading: false,

            marcasDía: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
                marca7: '',
                marca8: '',
                marca9: '',
                marca10: '',
                marca11: '',
                marca12: '',
                cantMarcas: '',
            },

            movimientos: {
                idInformes: '',
                numeroFuncionario: '',
                codigo: '',
                codigoMarcaM: '',
                codigoOmision: '',
                marcaOmitida: '',
                nombreFuncionario: '',
                dias: '0',
                minutos: '0',
                desde: '',
                hasta: '',
                anio: '',
                tipoMov: '1',
                tipoHS: '',
                tipoConsulta: '',
                notasGenerales: '',
            },

            marcasManual: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
                marca7: '',
                marca8: '',
            },

            movEditar: {
                idMovimiento: '',
                codigo: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                diasAnterior: '',
                minutosAnterior: '',
                dias: '',
                minutos: '',
                desde: '',
                hasta: '',
                anio: '',
            },

            busqueda: {
                numeroFuncionarioBusqueda: '',
                desdeBusqueda: '',
            },

            datoEspecifico: {},
            consultaEspecifica: false,

        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarEnvioMovimiento = this.manejarEnvioMovimiento.bind(this);
        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.manejarCambioEditar = this.manejarCambioEditar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarCambiosMarcaManual = this.manejarCambiosMarcaManual.bind(this);
        this.manejarEnviarMarcaManual = this.manejarEnviarMarcaManual.bind(this);
        this.manejarEnvioReingreso = this.manejarEnvioReingreso.bind(this);
        this.manejarEnvioMediaHora = this.manejarEnvioMediaHora.bind(this);
        this.manejarConsultaInforme = this.manejarConsultaInforme.bind(this);
        this.manejarAtrasEspecifica = this.manejarAtrasEspecifica.bind(this);
    }

    async componentDidMount(){
        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_codigosMovimientos.php`);
        const datos = await respuesta.json();
        this.setState({
            codigosMovimientos: datos,
        });

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };
    
    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.movimientosFuncionario.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };

    render() {
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.movimientosFuncionario.length;
        return (
            <>
                <Container>
                <h3>Movimientos</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.consulta
                ?
                    null
                :
                    <form className='formulario1'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambioNumFun} type="number" />
                                </Grid>
                                <Grid item xs={3}>
                                    <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desdeBusqueda' value={this.state.busqueda.desdeBusqueda} onChange={this.manejarCambioNumFun}/>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                }
                {this.state.movimientos.codigo === '59' ? (<div className='alert alert-danger'> SOLO SE DEBEN INGRESAR LAS MARCAS FALTANTES!</div>) : null}
                {this.state.consulta && (!this.state.consultaEspecifica)
                ?
                    <Container>
                        {/*<TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell width={'16%'}>Concepto</StyledTableCell>
                                        <StyledTableCell>Número</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Desde</StyledTableCell>
                                        <StyledTableCell>Hasta</StyledTableCell>
                                        <StyledTableCell>Año</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.movimientosFuncionario.map((datosAg) => (
                                        <StyledTableRow key={datosAg.idMovimiento}>
                                                    {this.state.codigosMovimientos.map((name) => {
                                                        if(name.idCodigoMovimiento === datosAg.codigo){
                                                            desc = name.descripcion;
                                                        }
                                                    })}
                                            <StyledTableCell>{desc}</StyledTableCell>
                                            <StyledTableCell>{datosAg.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosAg.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{ datosAg.desde.substring(8,10) + '/' + datosAg.desde.substring(5,7) + '/' + datosAg.desde.substring(0,4)}</StyledTableCell>
                                            <StyledTableCell>{ datosAg.hasta.substring(8,10) + '/' + datosAg.hasta.substring(5,7) + '/' + datosAg.hasta.substring(0,4)}</StyledTableCell>
                                            <StyledTableCell>{datosAg.anio}</StyledTableCell>
                                            {datosAg.idInformes === null || datosAg.idInformes === 0 ? <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.manejarEdicion(datosAg)}>Editar</button></StyledTableCell> : null}
                                            {datosAg.idInformes === null || datosAg.idInformes === 0 ? <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosAg)}>Borrar</button></StyledTableCell> : null}
                                            <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(datosAg)}>Consultar</button></StyledTableCell>
                                            {datosAg.idInformes !== null && datosAg.idInformes !== 0 ? <StyledTableCell align="center" colSpan={2}>Ingresado por informe</StyledTableCell> : null}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>*/}
                        {/*-----------------------------------------------------------*/}
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell width={'16%'}>Concepto</StyledTableCell>
                                        <StyledTableCell>Número</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Desde</StyledTableCell>
                                        <StyledTableCell>Hasta</StyledTableCell>
                                        <StyledTableCell>Año</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.movimientosFuncionario.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((datosAg) => (
                                        <StyledTableRow key={datosAg.idMovimiento}>
                                                    {this.state.codigosMovimientos.map((name) => {
                                                        if(name.idCodigoMovimiento === datosAg.codigo){
                                                            desc = name.descripcion;
                                                        }
                                                    })}
                                            <StyledTableCell>{desc}</StyledTableCell>
                                            <StyledTableCell>{datosAg.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosAg.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{ datosAg.desde.substring(8,10) + '/' + datosAg.desde.substring(5,7) + '/' + datosAg.desde.substring(0,4)}</StyledTableCell>
                                            <StyledTableCell>{ datosAg.hasta.substring(8,10) + '/' + datosAg.hasta.substring(5,7) + '/' + datosAg.hasta.substring(0,4)}</StyledTableCell>
                                            <StyledTableCell>{datosAg.anio}</StyledTableCell>
                                            {datosAg.idInformes === null || datosAg.idInformes === 0 ? <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.manejarEdicion(datosAg)}>Editar</button></StyledTableCell> : null}
                                            {datosAg.idInformes === null || datosAg.idInformes === 0 ? <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosAg)}>Borrar</button></StyledTableCell> : null}
                                            <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(datosAg)}>Consultar</button></StyledTableCell>
                                            {datosAg.idInformes !== null && datosAg.idInformes !== 0 ? <StyledTableCell align="center" colSpan={2}>Ingresado por informe</StyledTableCell> : null}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                        {/*-----------------------------------------------------------*/}
                    </Container>
                :
                    this.state.consulta
                    ?
                        null
                    :
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell width={'16%'}>Concepto</StyledTableCell>
                                        {(this.state.movimientos.codigo == '78' || this.state.movimientos.codigo == '28' || this.state.movimientos.codigo == '46' || this.state.movimientos.codigo === '37' || this.state.movimientos.codigo === '38' || this.state.movimientos.codigo === '35' || this.state.movimientos.codigo === '30' || this.state.movimientos.codigo === '60' || this.state.movimientos.codigo === '41' || this.state.movimientos.codigo === '72') && !this.state.consulta ? <StyledTableCell></StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' ? <StyledTableCell>Tipo Marca</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '62' ? <StyledTableCell>Tipo Omisión</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '62' && this.state.movimientos.codigoOmision === '1' ? <StyledTableCell>Marca</StyledTableCell> : null}
                                        <StyledTableCell>Número</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        {this.state.movimientos.codigo !== '68' && this.state.movimientos.codigo !== '59' && this.state.movimientos.codigo !== '69' && this.state.movimientos.codigo !== '10' && this.state.movimientos.codigo !== '60' && this.state.movimientos.codigo !== '61' && this.state.movimientos.codigo !== '62' && this.state.movimientos.codigo !== '65' && this.state.movimientos.codigo !== '21' && this.state.movimientos.codigo !== '43' && this.state.movimientos.codigo !== '53' && this.state.movimientos.codigo !== '25' && this.state.movimientos.codigo !== '72'
                                        ?
                                            this.state.movimientos.codigo === '81' || this.state.movimientos.codigo === '80' || this.state.movimientos.codigo === '30' || this.state.movimientos.codigo === '79' || this.state.movimientos.codigo === '78' || this.state.movimientos.codigo === '63' || this.state.movimientos.codigo === '66' || this.state.movimientos.codigo === '3' || this.state.movimientos.codigo === '22' || this.state.movimientos.codigo === '23' || this.state.movimientos.codigo === '41' || this.state.movimientos.codigo === '70' || this.state.movimientos.codigo === '7' || this.state.movimientos.codigo === '8' || this.state.movimientos.codigo === '9' || this.state.movimientos.codigo === '14' || this.state.movimientos.codigo === '15' || this.state.movimientos.codigo === '20' || this.state.movimientos.codigo === '27' || this.state.movimientos.codigo === '32' || this.state.movimientos.codigo === '34' || this.state.movimientos.codigo === '39' || this.state.movimientos.codigo === '45' || this.state.movimientos.codigo === '48' || this.state.movimientos.codigo === '49' || this.state.movimientos.codigo === '51' || this.state.movimientos.codigo === '54' || this.state.movimientos.codigo === '55' || this.state.movimientos.codigo === '56' || this.state.movimientos.codigo === '67'
                                            ?
                                                null
                                            :
                                                <StyledTableCell>Días</StyledTableCell>
                                        :
                                            <StyledTableCell>Fecha</StyledTableCell>
                                        }
                                        {this.state.movimientos.codigo === '60' && (this.state.movimientos.tipoHS === '2' || this.state.movimientos.tipoHS === '3' || this.state.movimientos.tipoHS === '4') ? <StyledTableCell>Minutos</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' ? this.state.movimientos.codigoMarcaM === '3' ? <StyledTableCell>Marca</StyledTableCell> : null : null}
                                        {this.state.movimientos.codigo !== '81' && this.state.movimientos.codigo !== '80' && this.state.movimientos.codigo !== '79' && this.state.movimientos.codigo !== '76' && this.state.movimientos.codigo !== '59' && this.state.movimientos.codigo !== '60' && this.state.movimientos.codigo !== '61' && this.state.movimientos.codigo !== '62' && this.state.movimientos.codigo !== '65' && this.state.movimientos.codigo !== '63' && this.state.movimientos.codigo !== '66' && this.state.movimientos.codigo !== '67' && this.state.movimientos.codigo !== '3' && this.state.movimientos.codigo !== '22' && this.state.movimientos.codigo !== '23' && this.state.movimientos.codigo !== '68' && this.state.movimientos.codigo !== '5' && this.state.movimientos.codigo !== '52' && this.state.movimientos.codigo !== '69' && this.state.movimientos.codigo !== '26' && this.state.movimientos.codigo !== '1' && this.state.movimientos.codigo !== '2' && this.state.movimientos.codigo !== '4' && this.state.movimientos.codigo !== '7' && this.state.movimientos.codigo !== '8' && this.state.movimientos.codigo !== '9' && this.state.movimientos.codigo !== '10' && this.state.movimientos.codigo !== '11' && this.state.movimientos.codigo !== '12' && this.state.movimientos.codigo !== '13' && this.state.movimientos.codigo !== '14' && this.state.movimientos.codigo !== '15' && this.state.movimientos.codigo !== '16' && this.state.movimientos.codigo !== '17' && this.state.movimientos.codigo !== '18' && this.state.movimientos.codigo !== '19' && this.state.movimientos.codigo !== '20' && this.state.movimientos.codigo !== '21' && this.state.movimientos.codigo !== '29' && this.state.movimientos.codigo !== '31' && this.state.movimientos.codigo !== '34' && this.state.movimientos.codigo !== '39' && this.state.movimientos.codigo !== '40' && this.state.movimientos.codigo !== '42' && this.state.movimientos.codigo !== '43' && this.state.movimientos.codigo !== '45' && this.state.movimientos.codigo !== '47' && this.state.movimientos.codigo !== '48' && this.state.movimientos.codigo !== '49' && this.state.movimientos.codigo !== '51' && this.state.movimientos.codigo !== '53' && this.state.movimientos.codigo !== '54' && this.state.movimientos.codigo !== '55' && this.state.movimientos.codigo !== '56' && this.state.movimientos.codigo !== '57' && this.state.movimientos.codigo !== '25'
                                        ?
                                            <StyledTableCell>Minutos</StyledTableCell>
                                        :
                                            this.state.movimientos.codigo !== '81' && this.state.movimientos.codigo !== '80' && this.state.movimientos.codigo !== '79' && this.state.movimientos.codigo !== '76' && this.state.movimientos.codigo !== '61' && this.state.movimientos.codigo !== '63' && this.state.movimientos.codigo !== '65' && this.state.movimientos.codigo !== '66' && this.state.movimientos.codigo !== '67' && this.state.movimientos.codigo !== '3' && this.state.movimientos.codigo !== '22' && this.state.movimientos.codigo !== '23' && this.state.movimientos.codigo !== '68' && this.state.movimientos.codigo !== '5' && this.state.movimientos.codigo !== '52' && this.state.movimientos.codigo !== '26' && this.state.movimientos.codigo !== '1' && this.state.movimientos.codigo !== '2' && this.state.movimientos.codigo !== '4' && this.state.movimientos.codigo !== '7' && this.state.movimientos.codigo !== '8' && this.state.movimientos.codigo !== '9' && this.state.movimientos.codigo !== '10' && this.state.movimientos.codigo !== '11' && this.state.movimientos.codigo !== '12' && this.state.movimientos.codigo !== '13' && this.state.movimientos.codigo !== '14' && this.state.movimientos.codigo !== '15' && this.state.movimientos.codigo !== '16' && this.state.movimientos.codigo !== '17' && this.state.movimientos.codigo !== '18' && this.state.movimientos.codigo !== '19' && this.state.movimientos.codigo !== '20' && this.state.movimientos.codigo !== '21' && this.state.movimientos.codigo !== '29' && this.state.movimientos.codigo !== '31' && this.state.movimientos.codigo !== '34' && this.state.movimientos.codigo !== '39' && this.state.movimientos.codigo !== '40' && this.state.movimientos.codigo !== '42' && this.state.movimientos.codigo !== '43' && this.state.movimientos.codigo !== '45' && this.state.movimientos.codigo !== '47' && this.state.movimientos.codigo !== '48' && this.state.movimientos.codigo !== '49' && this.state.movimientos.codigo !== '51' && this.state.movimientos.codigo !== '53' && this.state.movimientos.codigo !== '54' && this.state.movimientos.codigo !== '55' && this.state.movimientos.codigo !== '56' && this.state.movimientos.codigo !== '57' && this.state.movimientos.codigo !== '25'
                                            ?
                                                <StyledTableCell></StyledTableCell>
                                            :
                                                null
                                        }
                                        {(this.state.movimientos.codigo === '5') || (this.state.movimientos.codigo === '52') ? <StyledTableCell>Cantidad de Pruebas</StyledTableCell> : null}
                                        {this.state.movimientos.codigo !== '59' && this.state.movimientos.codigo !== '60' && this.state.movimientos.codigo !== '62' && this.state.movimientos.codigo !== '63' && this.state.movimientos.codigo !== '65' && this.state.movimientos.codigo !== '68' && this.state.movimientos.codigo !== '69' && this.state.movimientos.codigo !== '26' && this.state.movimientos.codigo !== '70' && this.state.movimientos.codigo !== '10' && this.state.movimientos.codigo !== '21' && this.state.movimientos.codigo !== '32' && this.state.movimientos.codigo !== '41' && this.state.movimientos.codigo !== '43' && this.state.movimientos.codigo !== '53' && this.state.movimientos.codigo !== '25' && this.state.movimientos.codigo !== '72' && this.state.movimientos.codigo !== '76' && this.state.movimientos.codigo !== '78' && this.state.movimientos.codigo !== '79' ? <StyledTableCell>Desde</StyledTableCell> : null}
                                        {this.state.movimientos.codigo !== '59' && this.state.movimientos.codigo !== '60' && this.state.movimientos.codigo !== '62' && this.state.movimientos.codigo !== '63' && this.state.movimientos.codigo !== '65' && this.state.movimientos.codigo !== '68' && this.state.movimientos.codigo !== '69' && this.state.movimientos.codigo !== '26' && this.state.movimientos.codigo !== '70' && this.state.movimientos.codigo !== '10' && this.state.movimientos.codigo !== '21' && this.state.movimientos.codigo !== '32' && this.state.movimientos.codigo !== '41' && this.state.movimientos.codigo !== '43' && this.state.movimientos.codigo !== '53' && this.state.movimientos.codigo !== '25' && this.state.movimientos.codigo !== '72' && this.state.movimientos.codigo !== '76' && this.state.movimientos.codigo !== '78' && this.state.movimientos.codigo !== '79' ? <StyledTableCell>Hasta</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '70' || this.state.movimientos.codigo === '32' || this.state.movimientos.codigo === '41' || this.state.movimientos.codigo === '78' ? <StyledTableCell>Fecha</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '61' ? <StyledTableCell></StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '65' ? <StyledTableCell>Notas Generales</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '78' ? <StyledTableCell>Motivo</StyledTableCell> : null}
                                        {this.state.movimientos.codigo !== '59' && this.state.movimientos.codigo !== '60' && this.state.movimientos.codigo !== '61' && this.state.movimientos.codigo !== '62' && this.state.movimientos.codigo !== '65' && this.state.movimientos.codigo !== '68' && this.state.movimientos.codigo !== '69' && this.state.movimientos.codigo !== '1' && this.state.movimientos.codigo !== '2' && this.state.movimientos.codigo !== '72' && this.state.movimientos.codigo !== '76' && this.state.movimientos.codigo !== '79' && this.state.movimientos.codigo !== '80' ? <StyledTableCell>Año</StyledTableCell> : null }
                                        {this.state.movimientos.codigo === '1' || this.state.movimientos.codigo === '2' || this.state.movimientos.codigo === '76' ? <StyledTableCell>Ejercicio</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '63' || this.state.movimientos.codigo === '68' ? <StyledTableCell></StyledTableCell> : null}
                                        {this.state.consulta ? <StyledTableCell></StyledTableCell> : ''}
                                        {this.state.consulta ? <StyledTableCell></StyledTableCell> : ''}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {/*Listo todo lo que voy agregando*/}
                                    {this.state.movimientosFuncionario.map((datosAg) => (
                                        <StyledTableRow key={datosAg.idMovimiento}>
                                                    {this.state.codigosMovimientos.map((name) => {
                                                        if(name.idCodigoMovimiento === datosAg.codigo){
                                                            desc = name.descripcion;
                                                        }
                                                    })}
                                            <StyledTableCell>{desc}</StyledTableCell>
                                            <StyledTableCell>{datosAg.numeroFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosAg.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>{datosAg.dias}</StyledTableCell>
                                            <StyledTableCell>{datosAg.minutos}</StyledTableCell>
                                            <StyledTableCell>{ datosAg.desde.substring(8,10) + '/' + datosAg.desde.substring(5,7) + '/' + datosAg.desde.substring(0,4)}</StyledTableCell>
                                            <StyledTableCell>{ datosAg.hasta.substring(8,10) + '/' + datosAg.hasta.substring(5,7) + '/' + datosAg.hasta.substring(0,4)}</StyledTableCell>
                                            <StyledTableCell>{datosAg.anio}</StyledTableCell>
                                            {datosAg.idInformes === 0 ? <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.manejarEdicion(datosAg)}>Editar</button></StyledTableCell> : null}
                                            {datosAg.idInformes === 0 ? <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosAg)}>Borrar</button></StyledTableCell> : null}
                                            {datosAg.idInformes !== 0 ? <StyledTableCell align="center" colSpan={2}>Ingresado por informe</StyledTableCell> : null}
                                        </StyledTableRow>
                                    ))}
                                    {/*Acá dejo siempre un espacio para seguir agregando*/}
                                    {this.state.consulta ? '' :
                                        <StyledTableRow>
                                            <StyledTableCell><select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.movimientos.codigo} onChange={this.manejarCambiosDatos}>
                                                            <option value=''>CONCEPTO</option>
                                                            {this.state.codigosMovimientos.map((name) =>
                                                                <option
                                                                key={name.idCodigoMovimiento}
                                                                value={name.idCodigoMovimiento}
                                                                >{name.descripcion}</option>
                                                                )}
                                                        </select>
                                            </StyledTableCell>
                                            {this.state.movimientos.codigo === '78'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoHS'  value={this.state.movimientos.tipoHS} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={1}>LLEGADA TARDE</option>
                                                        <option value={2}>SALIDA ANTES DE HORA</option>
                                                        <option value={3}>MEDIA HORA DE DESCANSO</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '46'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoHS'  value={this.state.movimientos.tipoHS} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={0}>COMPENSA DIA</option>
                                                        <option value={1}>COMPENSA LLEGADA TARDE</option>
                                                        <option value={2}>COMPENSA SALIDA ANTES DE HORA</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '28'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoHS'  value={this.state.movimientos.tipoHS} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={0}>COMPENSA DIA</option>
                                                        <option value={1}>COMPENSA LLEGADA TARDE</option>
                                                        <option value={2}>COMPENSA SALIDA ANTES DE HORA</option>
                                                        <option value={3}>SALIDA ENTRE HORARIO</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '72'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoHS'  value={this.state.movimientos.tipoHS} onChange={this.manejarCambiosDatos}>
                                                        <option value=''></option>
                                                        <option value={1}>COMPENSA LLEGADA TARDE</option>
                                                        <option value={2}>COMPENSA SALIDA ANTES DE HORA</option>
                                                        <option value={3}>SALIDA ENTRE HORARIO</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '35'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoHS'  value={this.state.movimientos.tipoHS} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={0}>DIA COMPLETO</option>
                                                        <option value={1}>LLEGADA TARDE</option>
                                                        <option value={2}>SALIDA ANTES DE HORA</option>
                                                        <option value={3}>SALIDA ENTRE HORARIO</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '37'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoConsulta'  value={this.state.movimientos.tipoConsulta} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={1}>Día Completo</option>
                                                        <option value={2}>Entrada Tarde</option>
                                                        <option value={3}>Salida Entre Horario</option>
                                                        <option value={4}>Salida Antes de Hora</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '30'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoHS'  value={this.state.movimientos.tipoHS} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={1}>Día Completo</option>
                                                        <option value={2}>Entrada Tarde</option>
                                                        <option value={3}>Salida Entre Horario</option>
                                                        <option value={4}>Salida Antes de Hora</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '60'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoHS'  value={this.state.movimientos.tipoHS} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={1}>Día Completo</option>
                                                        <option value={2}>Entrada Tarde</option>
                                                        <option value={3}>Salida Entre Horario</option>
                                                        <option value={4}>Salida Antes de Hora</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '41'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoHS'  value={this.state.movimientos.tipoHS} onChange={this.manejarCambiosDatos}>
                                                        <option value=''></option>
                                                        <option value={2}>Entrada Tarde</option>
                                                        <option value={3}>Salida Entre Horario</option>
                                                        <option value={4}>Salida Antes de Hora</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo === '38'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoConsulta'  value={this.state.movimientos.tipoConsulta} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO</option>
                                                        <option value={1}>Entrada Antes de Horario</option>
                                                        <option value={2}>Salida Despues de Horario</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo == 59
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoMarcaM'  value={this.state.movimientos.codigoMarcaM} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO DE MARCA</option>
                                                        <option value={1}>TELEFONO</option>
                                                        <option value={2}>TAREA EXTERNA</option>
                                                        <option value={3}>MEDIA HORA DESCANSO</option>
                                                        <option value={6}>CORRECCION DE MARCAS</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo == 62
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoOmision'  value={this.state.movimientos.codigoOmision} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>TIPO DE OMISION</option>
                                                        <option value={1}>MARCA</option>
                                                        {/*<option value={2}>MEDIA HORA DESCANSO</option>*/}
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {this.state.movimientos.codigo == 62 && this.state.movimientos.codigoOmision === '1'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='marcaOmitida'  value={this.state.movimientos.marcaOmitida} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>MARCA</option>
                                                        <option value={1}>ENTRADA</option>
                                                        <option value={2}>ENTRADA MEDIA HORA</option>
                                                        <option value={3}>SALIDA MEDIA HORA</option>
                                                        <option value={4}>SALIDA</option>
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.movimientos.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>{this.state.movimientos.nombreFuncionario}</StyledTableCell>
                                            {this.state.movimientos.codigo === '59' || this.state.movimientos.codigo === '60' || this.state.movimientos.codigo === '61' || this.state.movimientos.codigo === '62' || this.state.movimientos.codigo === '63' || this.state.movimientos.codigo === '65' || this.state.movimientos.codigo === '66' || this.state.movimientos.codigo === '3' || this.state.movimientos.codigo === '22' || this.state.movimientos.codigo === '23' || this.state.movimientos.codigo === '68' || this.state.movimientos.codigo === '69' || this.state.movimientos.codigo === '41' || this.state.movimientos.codigo === '70' || this.state.movimientos.codigo === '7' || this.state.movimientos.codigo === '8' || this.state.movimientos.codigo === '9' || this.state.movimientos.codigo === '10' || this.state.movimientos.codigo === '14' || this.state.movimientos.codigo === '15' || this.state.movimientos.codigo === '20' || this.state.movimientos.codigo === '21' || this.state.movimientos.codigo === '27' || this.state.movimientos.codigo === '32' || this.state.movimientos.codigo === '34' || this.state.movimientos.codigo === '39' || this.state.movimientos.codigo === '41' || this.state.movimientos.codigo === '43' || this.state.movimientos.codigo === '45' || this.state.movimientos.codigo === '48' || this.state.movimientos.codigo === '49' || this.state.movimientos.codigo === '51' || this.state.movimientos.codigo === '53' || this.state.movimientos.codigo === '54' || this.state.movimientos.codigo === '55' || this.state.movimientos.codigo === '56' || this.state.movimientos.codigo === '67' || this.state.movimientos.codigo === '25' || this.state.movimientos.codigo === '72' || this.state.movimientos.codigo === '78' || this.state.movimientos.codigo === '79' || this.state.movimientos.codigo === '30' || this.state.movimientos.codigo === '80' || this.state.movimientos.codigo === '81' ? null : this.state.ingresoDias ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='dias' value={this.state.movimientos.dias} onChange={this.manejarCambiosDatos}/></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                            {this.state.movimientos.codigo === '59' || this.state.movimientos.codigo === '60' || this.state.movimientos.codigo === '61' || this.state.movimientos.codigo === '62' || this.state.movimientos.codigo === '63' || this.state.movimientos.codigo === '65' || this.state.movimientos.codigo === '66' || this.state.movimientos.codigo === '67' || this.state.movimientos.codigo === '3' || this.state.movimientos.codigo === '22' || this.state.movimientos.codigo === '23' || this.state.movimientos.codigo === '68' || this.state.movimientos.codigo === '69' || this.state.movimientos.codigo === '26' || this.state.movimientos.codigo === '1' || this.state.movimientos.codigo === '2' || this.state.movimientos.codigo === '4' || this.state.movimientos.codigo === '7' || this.state.movimientos.codigo === '8' || this.state.movimientos.codigo === '9' || this.state.movimientos.codigo === '10' || this.state.movimientos.codigo === '11' || this.state.movimientos.codigo === '12' || this.state.movimientos.codigo === '13' || this.state.movimientos.codigo === '14' || this.state.movimientos.codigo === '15' || this.state.movimientos.codigo === '16' || this.state.movimientos.codigo === '17' || this.state.movimientos.codigo === '18' || this.state.movimientos.codigo === '19' || this.state.movimientos.codigo === '20' || this.state.movimientos.codigo === '21' || this.state.movimientos.codigo === '29' || this.state.movimientos.codigo === '31' || this.state.movimientos.codigo === '34' || this.state.movimientos.codigo === '39' || this.state.movimientos.codigo === '40' || this.state.movimientos.codigo === '42' || this.state.movimientos.codigo === '43' || this.state.movimientos.codigo === '45' || this.state.movimientos.codigo === '47' || this.state.movimientos.codigo === '48' || this.state.movimientos.codigo === '49' || this.state.movimientos.codigo === '51' || this.state.movimientos.codigo === '53' || this.state.movimientos.codigo === '54' || this.state.movimientos.codigo === '55' || this.state.movimientos.codigo === '56' || this.state.movimientos.codigo === '57' || this.state.movimientos.codigo === '25' || this.state.movimientos.codigo === '72' || this.state.movimientos.codigo === '76' || this.state.movimientos.codigo === '79' || this.state.movimientos.codigo === '80' || this.state.movimientos.codigo === '81' ? null : this.state.ingresoMinutos ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='minutos' value={this.state.movimientos.minutos} onChange={this.manejarCambiosDatos}/></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                            {this.state.movimientos.codigo !== '63' && this.state.movimientos.codigo !== '26' && this.state.movimientos.codigo !== '76' && this.state.movimientos.codigo !== '79' ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.movimientos.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {this.state.movimientos.codigo === '60' && (this.state.movimientos.tipoHS === '2' || this.state.movimientos.tipoHS === '3' || this.state.movimientos.tipoHS === '4') ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='minutos' value={this.state.movimientos.minutos} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {this.state.movimientos.codigo === '59' ? this.state.movimientos.codigoMarcaM === '3' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca1' value={this.state.marcasManual.marca1} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell> : null : null}
                                            {this.state.movimientos.codigo === '72' || this.state.movimientos.codigo === '59' || this.state.movimientos.codigo === '60' || this.state.movimientos.codigo === '61' || this.state.movimientos.codigo === '62' || this.state.movimientos.codigo === '63' || this.state.movimientos.codigo === '65' || this.state.movimientos.codigo === '68' || this.state.movimientos.codigo === '69' || this.state.movimientos.codigo === '26' || this.state.movimientos.codigo === '70' || this.state.movimientos.codigo === '10' || this.state.movimientos.codigo === '21' || this.state.movimientos.codigo === '32' || this.state.movimientos.codigo === '41' || this.state.movimientos.codigo === '43' || this.state.movimientos.codigo === '53' || this.state.movimientos.codigo === '25' || this.state.movimientos.codigo === '76' || this.state.movimientos.codigo === '78' || this.state.movimientos.codigo === '79' ? null : <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='hasta' value={this.state.movimientos.hasta} onChange={this.manejarCambiosDatos}/></StyledTableCell> }
                                            {this.state.movimientos.codigo === '78' ? <StyledTableCell><textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={5} cols={30} id='notasGenerales' value={this.state.movimientos.notasGenerales} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {this.state.movimientos.codigo === '59' || this.state.movimientos.codigo === '60' || this.state.movimientos.codigo === '61' || this.state.movimientos.codigo === '62' || this.state.movimientos.codigo === '65' || this.state.movimientos.codigo === '68' || this.state.movimientos.codigo === '69' || this.state.movimientos.codigo === '72' || this.state.movimientos.codigo === '79' || this.state.movimientos.codigo === '80' ? null : <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.movimientos.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell> }
                                            {this.state.movimientos.codigo === '72' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='minutos' value={this.state.movimientos.minutos} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {this.state.movimientos.codigo === '61' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca1' value={this.state.marcasManual.marca1} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell> : null}
                                            {this.state.movimientos.codigo === '61' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca2' value={this.state.marcasManual.marca2} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell> : null}
                                            {this.state.movimientos.codigo === '68' || this.state.movimientos.codigo === '59' || this.state.movimientos.codigo === '60' || this.state.movimientos.codigo === '61' || this.state.movimientos.codigo === '62' || this.state.movimientos.codigo === '63' || this.state.movimientos.codigo === '69' ? <StyledTableCell><button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioMovimiento}>{this.state.movimientos.codigoMarcaM === '3' || this.state.movimientos.codigo === '60'|| this.state.movimientos.codigo === '61'|| this.state.movimientos.codigo === '62'|| this.state.movimientos.codigo === '63' ? 'Agregar' : 'Buscar'}</button></StyledTableCell> : null}
                                            {/*this.state.movimientos.codigo === '65' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='notasGenerales' value={this.state.movimientos.notasGenerales} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null*/}
                                            {this.state.movimientos.codigo === '65' ? <StyledTableCell><textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={5} cols={20} id='notasGenerales' value={this.state.movimientos.notasGenerales} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                        </StyledTableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                }
                {this.state.consultaMarcaDia ? <br/> : null}
                {this.state.consultaMarcaDia ? <br/> : null}
                {this.state.consultaMarcaDia
                ?
                    <Container>
                        {this.state.marcasDía.cantMarcas > 6
                        ?
                            <h5 style={{color: 'red'}}>Posee mas de 6 Marcas</h5>
                        :
                            null
                        }
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" colSpan={16}>
                                            MARCA:  {this.state.marcasDía.numeroFuncionario} {this.state.marcasDía.nombreFuncionario}
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Marca1</StyledTableCell>
                                        <StyledTableCell>Marca2</StyledTableCell>
                                        <StyledTableCell>Marca3</StyledTableCell>
                                        <StyledTableCell>Marca4</StyledTableCell>
                                        <StyledTableCell>Marca5</StyledTableCell>
                                        <StyledTableCell>Marca6</StyledTableCell>
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>Marca7</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>Marca8</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>Marca9</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>Marca10</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>Marca11</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>Marca12</StyledTableCell> : null}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell>{this.state.marcasDía.marca1}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca2}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca3}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca4}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca5}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca6}</StyledTableCell>
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>{this.state.marcasDía.marca7}</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>{this.state.marcasDía.marca8}</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>{this.state.marcasDía.marca9}</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>{this.state.marcasDía.marca10}</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>{this.state.marcasDía.marca11}</StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell>{this.state.marcasDía.marca12}</StyledTableCell> : null}
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca1' value={this.state.marcasManual.marca1} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca2' value={this.state.marcasManual.marca2} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca3' value={this.state.marcasManual.marca3} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca4' value={this.state.marcasManual.marca4} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca5' value={this.state.marcasManual.marca5} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca6' value={this.state.marcasManual.marca6} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell></StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell></StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell></StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell></StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell></StyledTableCell> : null}
                                        {this.state.movimientos.codigo === '59' && this.state.movimientos.codigoMarcaM === '6' ? <StyledTableCell></StyledTableCell> : null}
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                :
                    null
                }
                {this.state.consultaReingreso ? <br/> : null}
                {this.state.consultaReingreso ? <br/> : null}
                {this.state.consultaReingreso
                ?
                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center" colSpan={10}>
                                        MARCA:  {this.state.marcasDía.numeroFuncionario} {this.state.marcasDía.nombreFuncionario}
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Marca1</StyledTableCell>
                                    <StyledTableCell>Marca2</StyledTableCell>
                                    <StyledTableCell>Marca3</StyledTableCell>
                                    <StyledTableCell>Marca4</StyledTableCell>
                                    <StyledTableCell>Marca5</StyledTableCell>
                                    <StyledTableCell>Marca6</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell>{this.state.marcasDía.marca1}</StyledTableCell>
                                    <StyledTableCell>{this.state.marcasDía.marca2}</StyledTableCell>
                                    <StyledTableCell>{this.state.marcasDía.marca3}</StyledTableCell>
                                    <StyledTableCell>{this.state.marcasDía.marca4}</StyledTableCell>
                                    <StyledTableCell>{this.state.marcasDía.marca5}</StyledTableCell>
                                    <StyledTableCell>{this.state.marcasDía.marca6}</StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                            
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center" colSpan={10}>
                                        INGRESE EL NUMERO DE LA MARCA DE REINGRESO
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='marca1'  value={this.state.marcasManual.marca1} onChange={this.manejarCambiosMarcaManual}>
                                            <option value=''>MARCA</option>
                                            <option value={1}>MARCA 1</option>
                                            <option value={2}>MARCA 2</option>
                                            <option value={3}>MARCA 3</option>
                                            <option value={4}>MARCA 4</option>
                                            <option value={5}>MARCA 5</option>
                                            <option value={6}>MARCA 6</option>
                                        </select>
                                    </StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                :
                    null
                }
                {this.state.consultaMediaHora ? <br/> : null}
                {this.state.consultaMediaHora ? <br/> : null}
                {this.state.consultaMediaHora
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" colSpan={10}>
                                            MARCA:  {this.state.marcasDía.numeroFuncionario} {this.state.marcasDía.nombreFuncionario}
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Marca1</StyledTableCell>
                                        <StyledTableCell>Marca2</StyledTableCell>
                                        <StyledTableCell>Marca3</StyledTableCell>
                                        <StyledTableCell>Marca4</StyledTableCell>
                                        <StyledTableCell>Marca5</StyledTableCell>
                                        <StyledTableCell>Marca6</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell>{this.state.marcasDía.marca1}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca2}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca3}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca4}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca5}</StyledTableCell>
                                        <StyledTableCell>{this.state.marcasDía.marca6}</StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca1' value={this.state.marcasManual.marca1} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca2' value={this.state.marcasManual.marca2} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca3' value={this.state.marcasManual.marca3} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca4' value={this.state.marcasManual.marca4} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca5' value={this.state.marcasManual.marca5} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="time" id='marca6' value={this.state.marcasManual.marca6} onChange={this.manejarCambiosMarcaManual}/></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                :
                    null
                }
                {this.state.consultaEspecifica
                ?
                    <Container>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                {this.state.codigosMovimientos.map((name2) => {
                                    if(name2.idCodigoMovimiento === this.state.datoEspecifico.codigo){
                                        desc = name2.descripcion;
                                    }
                                })}
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                    {desc}
                                </Grid>
                                <Grid item xs={4}>
                                </Grid>
                                {/*Esto va siempre */}
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Número</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    {this.state.datoEspecifico.numeroFuncionario}
                                </Grid>
                                <Grid item xs={1}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Nombre</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    {this.state.datoEspecifico.nombreFuncionario}
                                </Grid>
                                <Grid item xs={1}>
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                {this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 26 || this.state.datoEspecifico.codigo === 26 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        <Item>Días</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 26 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.dias}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27
                                ?
                                    <Grid item xs={2}>
                                        <Item>Minutos</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.minutos}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 26 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        <Item>Desde</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 65 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 53 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 25 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                        <Item>Fecha</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 65 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 53 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 25 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 65 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 53 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 25 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        <Item>Hasta</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.hasta).substring(8,10) + '/' + String(this.state.datoEspecifico.hasta).substring(5,7) + '/' + String(this.state.datoEspecifico.hasta).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 63 || this.state.datoEspecifico.codigo === 26 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2
                                ?
                                    <Grid item xs={2}>
                                        <Item>Ejercicio</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 21
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 63 || this.state.datoEspecifico.codigo === 26 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 2
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.anio}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 53 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 25 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        <Item>Año</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 70 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 57 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 55 || this.state.datoEspecifico.codigo === 54 || this.state.datoEspecifico.codigo === 53 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 49 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 45 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 39 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 27 || this.state.datoEspecifico.codigo === 25 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 20 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 18 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 9 || this.state.datoEspecifico.codigo === 8 || this.state.datoEspecifico.codigo === 7 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.anio}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 5
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 5
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        <Item>Desde</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.salidaSEH}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        <Item>Hasta</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.entradaSEH}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 5
                                ?
                                    <Grid item xs={2}>
                                        <Item>Cantidad de Pruebas</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 5
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.cantidadPruebas}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 41 || this.state.datoEspecifico.codigo === 38 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28
                                ?
                                    <Grid item xs={2}>
                                        <Item>Tipo</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 72 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 28
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipoHS === 0
                                        ?
                                            'DIA COMPLETO'
                                        :
                                            this.state.datoEspecifico.tipoHS === 1
                                            ?
                                                'LLEGADA TARDE'
                                            :
                                                this.state.datoEspecifico.tipoHS === 2
                                                ?
                                                    'SALIDA ANTES DE HORA'
                                                :
                                                    this.state.datoEspecifico.tipoHS === 3
                                                    ?
                                                        'SALIDA ENTRE HORARIO'
                                                    :
                                                        null
                                        }
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 41
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipoHS === 2
                                            ?
                                                'LLEGADA TARDE'
                                            :
                                                this.state.datoEspecifico.tipoHS === 4
                                                ?
                                                    'SALIDA ANTES DE HORA'
                                                :
                                                    this.state.datoEspecifico.tipoHS === 3
                                                    ?
                                                        'SALIDA ENTRE HORARIO'
                                                    :
                                                        null
                                        }
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 37
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipoConsulta === 0
                                        ?
                                            'DIA COMPLETO'
                                        :
                                            this.state.datoEspecifico.tipoConsulta === 1
                                            ?
                                                'LLEGADA TARDE'
                                            :
                                                this.state.datoEspecifico.tipoConsulta === 2
                                                ?
                                                    'SALIDA ANTES DE HORA'
                                                :
                                                    this.state.datoEspecifico.tipoConsulta === 3
                                                    ?
                                                        'SALIDA ENTRE HORARIO'
                                                    :
                                                        null
                                        }
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 60
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipoHS === 1
                                        ?
                                            'DIA COMPLETO'
                                        :
                                            this.state.datoEspecifico.tipoHS === 2
                                            ?
                                                'LLEGADA TARDE'
                                            :
                                                this.state.datoEspecifico.tipoHS === 4
                                                ?
                                                    'SALIDA ANTES DE HORA'
                                                :
                                                    this.state.datoEspecifico.tipoHS === 3
                                                    ?
                                                        'SALIDA ENTRE HORARIO'
                                                    :
                                                        null
                                        }
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 38
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipoConsulta === 1
                                        ?
                                            'ENTRADA ANTES DE HORA'
                                        :
                                            this.state.datoEspecifico.tipoConsulta === 2
                                            ?
                                                'SALIDA DESPUES DE HORA'
                                            :
                                                null
                                        }
                                    </Grid>
                                :
                                    null
                                }
                            </Grid>
                        </Box>
                        <br/>
                        {this.state.datoEspecifico.codigo === 65 ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='notasGenerales' value={this.state.datoEspecifico.notasGenerales} disabled/> : null}
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasEspecifica}>Volver</button>
                    </Container>
                :
                    null
                }
                <br/>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.consulta ? '' : this.state.movimientos.codigo === '59' || this.state.movimientos.codigo === '60' || this.state.movimientos.codigo === '68' || this.state.movimientos.codigo === '69' ? null : <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioMovimiento}>Agregar</button>}
                {this.state.consulta && (!this.state.consultaEspecifica) ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : ''}
                {this.state.consultaMarcaDia ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnviarMarcaManual}>Enviar</button> : null}
                {this.state.consultaReingreso ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioReingreso}>Enviar</button> : null}
                {this.state.consultaMediaHora ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioMediaHora}>Enviar</button> : null}
                </Container>
                <Modal open={this.state.modalActualizar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                        <h3 style={{textAlign:'center'}}>Editar Movimiento</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={6}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item>{this.state.movEditar.numeroFuncionario}</Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Días</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='dias' value={this.state.movEditar.dias} onChange={this.manejarCambioEditar} type="number" /></Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Minutos</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='minutos' value={this.state.movEditar.minutos} onChange={this.manejarCambioEditar} type="number" /></Item>
                                </Grid>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Desde</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='desde' value={this.state.movEditar.desde} onChange={this.manejarCambioEditar} type="date" /></Item>
                                </Grid>
                                <Grid item xs={2}>
                                    
                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Hasta</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='hasta' value={this.state.movEditar.hasta} onChange={this.manejarCambioEditar} type="date" /></Item>
                                </Grid>
                                <Grid item xs={2}>
                                    
                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Año</Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.movEditar.anio} onChange={this.manejarCambioEditar} type="number" /></Item>
                                </Grid>
                                <Grid item xs={2}>
                                    
                                </Grid>
                                <Grid item xs={2}>
                                    
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
                <Modal open={this.state.modalBorrar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                        <h3 style={{textAlign:'center'}}>¿Confirmar Baja Movimiento?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
            </>

        )//Final return
    }//Final render


    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.busqueda.numeroFuncionarioBusqueda === ''){
            this.setState({
                errores: "DEBE INGRESAR UN NUMERO DE FUNCIONARIO!",
            });
        }else if(this.state.busqueda.desdeBusqueda === ''){
            this.setState({
                errores: "DEBE INGRESAR LA FECHA DESDE!",
            });
        }else{
            this.setState({
                errores: null,
                loading: true,
            });
            this.setState({
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify(this.state.busqueda);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_movimientos.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            if(exito){
                if(exito.length !== 0){

                    this.setState({
                        consulta: true,
                        movimientosFuncionario: exito,
                        loading: false,
                    })
                }else{
                    this.setState({
                        consulta: false,
                        loading: false,
                        movimientosFuncionario: [],
                        errores: 'No existen movimientos para el número de funcionario ingresado!',
                    });
                }
            }
        }
    }

    async manejarEnvioMovimiento(e){
        e.preventDefault();
        const fechaActual = new Date();
        const anio = fechaActual.getFullYear();
        const mes = fechaActual.getMonth() + 1;
        const dia = String(fechaActual.getDate()).padStart(2,'0');
        //Controlar el ingreso de todos los campos que faltan
        const anioIngresadoDesde = this.state.movimientos.desde.substring(0,4);
        const mesIngresadoDesde = this.state.movimientos.desde.substring(5,7);
        const diaIngresadoDesde = this.state.movimientos.desde.substring(8,10);

        const anioIngresadoHasta = this.state.movimientos.hasta.substring(0,4);
        const mesIngresadoHasta = this.state.movimientos.hasta.substring(5,7);
        const diaIngresadoHasta = this.state.movimientos.hasta.substring(8,10);

        if(this.state.movimientos.codigo === ''){
            this.setState({
                errores: 'Debe seleccionar un concepto',
            });
        }else if((this.state.movimientos.tipoConsulta === '') && ((this.state.movimientos === '37') || (this.state.movimientos === '38'))){
            this.setState({
                errores: 'Debe ingresar el tipo de salida por Consulta Medica!',
            });
        }else if(this.state.movimientos.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un numero de funcionario valido',
            });
        }else if((this.state.movimientos.codigo === '46') && (this.state.movimientos.tipoHS === '')){
            this.setState({
                errores: 'Debe ingresar el tipo de descuento de Hora Simple',
            });
        }else if((this.state.movimientos.tipoHS === '') && (this.state.movimientos.codigo === '78')){
            this.setState({
                errores: 'Debe ingresar el tipo a compensar',
            });
        }else if((this.state.movimientos.codigo === '72') && (this.state.movimientos.tipoHS === '')){
            this.setState({
                errores: 'Debe ingresar el tipo de descuento',
            });
        }else if((this.state.movimientos.codigo === '28') && (this.state.movimientos.tipoHS === '')){
            this.setState({
                errores: 'Debe ingresar el tipo de descuento de Hora Inhábil',
            });
        }else if(((this.state.movimientos.codigo === '35') || (this.state.movimientos.codigo === '30') || (this.state.movimientos.codigo === '41')) && (this.state.movimientos.tipoHS === '')){
            this.setState({
                errores: 'Debe ingresar el tipo de salida',
            });
        }else if(this.state.movimientos.dias === '0' && this.state.movimientos.codigo !== '81' && this.state.movimientos.codigo !== '80' && this.state.movimientos.codigo !== '79' && this.state.movimientos.codigo !== '78' && this.state.movimientos.codigo !== '68' && this.state.movimientos.codigo !== '69' && this.state.movimientos.codigo !== '28' && this.state.movimientos.codigo !== '46' && this.state.movimientos.codigo !== '30' && this.state.movimientos.codigo !== '59'  && this.state.movimientos.codigo !== '60' && this.state.movimientos.codigo !== '61' && this.state.movimientos.codigo !== '62' && this.state.movimientos.codigo !== '63' && this.state.movimientos.codigo !== '37' && this.state.movimientos.codigo !== '38' && this.state.movimientos.codigo !== '65' && this.state.movimientos.codigo !== '66' && this.state.movimientos.codigo !== '3' && this.state.movimientos.codigo !== '22' && this.state.movimientos.codigo !== '23' && this.state.movimientos.codigo !== '35' && this.state.movimientos.codigo !== '41' && this.state.movimientos.codigo !== '70' && this.state.movimientos.codigo !== '7' && this.state.movimientos.codigo !== '8' && this.state.movimientos.codigo !== '9' && this.state.movimientos.codigo !== '10' && this.state.movimientos.codigo !== '14' && this.state.movimientos.codigo !== '15' && this.state.movimientos.codigo !== '20' && this.state.movimientos.codigo !== '21' && this.state.movimientos.codigo !== '27' && this.state.movimientos.codigo !== '32' && this.state.movimientos.codigo !== '34' && this.state.movimientos.codigo !== '39' && this.state.movimientos.codigo !== '43' && this.state.movimientos.codigo !== '45' && this.state.movimientos.codigo !== '48' && this.state.movimientos.codigo !== '49' && this.state.movimientos.codigo !== '51' && this.state.movimientos.codigo !== '53' && this.state.movimientos.codigo !== '54' && this.state.movimientos.codigo !== '55' && this.state.movimientos.codigo !== '56' && this.state.movimientos.codigo !== '67' && this.state.movimientos.codigo !== '25' && this.state.movimientos.codigo !== '72'){
            this.setState({
                errores: 'Debe ingresar la cantidad de días',
            });
        }else if((this.state.movimientos.minutos === '0') && ((this.state.movimientos.codigo === '60' && (this.state.movimientos.tipoHS === '2' || this.state.movimientos.tipoHS === '3' || this.state.movimientos.tipoHS === '4')) || this.state.movimientos.codigo === '78' || this.state.movimientos.codigo === '28' || this.state.movimientos.codigo === '46' || this.state.movimientos.codigo === '41' || this.state.movimientos.codigo === '70' || this.state.movimientos.codigo === '27' || this.state.movimientos.codigo === '32') && (this.state.movimientos.dias === '0')){
            this.setState({
                errores: 'Debe ingresar la cantidad de minutos',
            });
        }else if((this.state.movimientos.minutos === '' || this.state.movimientos.minutos === '0') && ((this.state.movimientos.codigo === '30'))){
            this.setState({
                errores: 'Debe ingresar la cantidad de minutos',
            });
        }else if((this.state.movimientos.desde === '') && (this.state.movimientos.codigo !== '79') && (this.state.movimientos.codigo !== '78') && (this.state.movimientos.codigo !== '76') && (this.state.movimientos.codigo !== '63') && (this.state.movimientos.codigo !== '26') && (this.state.movimientos.codigo !== '72')){
            this.setState({
                errores: 'Debe ingresar la fecha DESDE',
            });
        }else if((this.state.movimientos.desde === '') && ((this.state.movimientos.codigo === '72') || (this.state.movimientos.codigo === '78'))){
            this.setState({
                errores: 'Debe ingresar la Fecha',
            });
        }else if((this.state.movimientos.hasta === '') && (this.state.movimientos.codigo !== '79') && (this.state.movimientos.codigo !== '78') && (this.state.movimientos.codigo !== '76') && (this.state.movimientos.codigo !== '72') && (this.state.movimientos.codigo !== '10') && (this.state.movimientos.codigo !== '68') && (this.state.movimientos.codigo !== '69') && (this.state.movimientos.codigo !== '59') && (this.state.movimientos.codigo !== '60') && (this.state.movimientos.codigo !== '61') && (this.state.movimientos.codigo !== '62') && (this.state.movimientos.codigo !== '63') && (this.state.movimientos.codigo !== '65') && (this.state.movimientos.codigo !== '26') && (this.state.movimientos.codigo !== '70') && (this.state.movimientos.codigo !== '21') && (this.state.movimientos.codigo !== '32') && (this.state.movimientos.codigo !== '41') && (this.state.movimientos.codigo !== '43') && (this.state.movimientos.codigo !== '53') && (this.state.movimientos.codigo !== '25')){
            this.setState({
                errores: 'Debe ingresar la fecha HASTA',
            });
    }   else if(this.state.movimientos.notasGenerales === '' && this.state.movimientos.codigo === '78'){
                this.setState({
                    errores: 'Debe ingresar el Motivo!',
                });
        }else if(this.state.movimientos.anio === '' && this.state.movimientos.codigo !== '80' && this.state.movimientos.codigo !== '79' && this.state.movimientos.codigo !== '72' && this.state.movimientos.codigo !== '68' && this.state.movimientos.codigo !== '69' && this.state.movimientos.codigo !== '28' && this.state.movimientos.codigo !== '29' && this.state.movimientos.codigo !== '40' && this.state.movimientos.codigo !== '46' && this.state.movimientos.codigo !== '59' && this.state.movimientos.codigo !== '60' && this.state.movimientos.codigo !== '61' && this.state.movimientos.codigo !== '62' && this.state.movimientos.codigo !== '65'){
            this.setState({
                errores: 'Debe ingresar el Año!',
            });
        }else if(this.state.movimientos.notasGenerales === '' && this.state.movimientos.codigo === '65'){
            this.setState({
                errores: 'Debe ingresar un comentario!',
            });
        }else if(((this.state.movimientos.codigo === '59') && (this.state.movimientos.codigoMarcaM !== '3'))){
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify(this.state.movimientos);
            const control = await fetch(`${Constantes.RUTA_API}/obtener_marcaDia.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });

            if(res[0] === 'ok'){
                this.setState({
                    notificaciones: null,
                    errores: null,
                    marcasDía: res[1],
                    consultaMarcaDia: true,
                });
                //}
            }
            this.setState({
                loading: false,
            })
        }else if((this.state.movimientos.codigo === '59') && (this.state.movimientos.codigoMarcaM === '3')){
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            });
            const cargaUtil = JSON.stringify([this.state.marcasManual, this.state.movimientos, this.state.marcasDía]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_marcaManual.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito,
                loading: false,
            })

            if(exito === 'ok'){
                this.setState({
                    notificaciones: 'Las marcas fueron ingresadas correctamente',
                    errores: null,
                    consultaMarcaDia: false,
                    consultaReingreso: false,
                    marcasDía: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                        marca9: '',
                        marca10: '',
                        marca11: '',
                        marca12: '',
                        cantMarcas: '',
                    },
        
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
        
                    marcasManual: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                    },
                })
            }
        }else if((this.state.movimientos.codigo === '60')){
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            });
            const cargaUtil = JSON.stringify(this.state.movimientos);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_TareaExterna.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito,
                notificaciones: null,
            })

            if(exito === 'ok'){
                this.setState({
                    notificaciones: 'El movimiento fue ingresado correctamente',
                    errores: null,
                    consultaMarcaDia: false,
                    consultaReingreso: false,
                    consultaMediaHora: false,
                    marcasDía: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                        marca9: '',
                        marca10: '',
                        marca11: '',
                        marca12: '',
                        cantMarcas: '',
                    },
        
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
        
                    marcasManual: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                    },
                })
            }
            this.setState({
                loading: false,
            })
        }else if((this.state.movimientos.codigo === '61')){
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            });
            const cargaUtil = JSON.stringify([this.state.marcasManual, this.state.movimientos]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_SalidaEH.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito,
                notificaciones: null,
            });

            if(exito === 'ok'){
                this.setState({
                    notificaciones: 'El movimiento fue ingresado correctamente!',
                    errores: null,
                    consultaMarcaDia: false,
                    consultaMediaHora: false,
                    consultaReingreso: false,
                    marcasDía: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                        marca9: '',
                        marca10: '',
                        marca11: '',
                        marca12: '',
                        cantMarcas: '',
                    },
        
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
        
                    marcasManual: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                    },
                })
            }
            this.setState({
                loading: false,
            })
        }else if((this.state.movimientos.codigo === '62')){
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            });
            const cargaUtil = JSON.stringify(this.state.movimientos);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_Omision.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito[1],
                notificaciones: null,
            });

            if(exito[0] === 'ok'){
                this.setState({
                    notificaciones: 'El movimiento fue ingresado correctamente!',
                    consultaMarcaDia: false,
                    consultaMediaHora: false,
                    consultaReingreso: false,
                    marcasDía: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                        marca9: '',
                        marca10: '',
                        marca11: '',
                        marca12: '',
                        cantMarcas: '',
                    },
        
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
        
                    marcasManual: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                    },
                })
                if((exito[1] >= 6) || (exito[2] >= 6)){
                    this.setState({
                        errores: 'El funcionarion tiene ' + exito[1] + ' omisiones de entrada y salida y ' + exito[2] + ' omisiones de media hora de descanso',
                    })
                }else{
                    this.setState({
                        errores: null,
                    })
                }
            }
            this.setState({
                loading: false,
            })
        }else if((this.state.movimientos.codigo === '63')){
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            });
            const cargaUtil = JSON.stringify(this.state.movimientos);

            const respuesta = await fetch(`${Constantes.RUTA_API}/bajar_licenciaAntiguedad.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito,
                notificaciones: null,
            });

            if(exito === 'ok'){
                this.setState({
                    notificaciones: 'El movimiento fue ingresado correctamente!',
                    consultaMarcaDia: false,
                    consultaMediaHora: false,
                    consultaReingreso: false,
                    errores: null,
                    marcasDía: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                        marca9: '',
                        marca10: '',
                        marca11: '',
                        marca12: '',
                        cantMarcas: '',
                    },
        
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
        
                    marcasManual: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                    },
                })
            }
            this.setState({
                loading: false,
            })
        }else if((this.state.movimientos.codigo === '68')){
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify(this.state.movimientos);
            const control = await fetch(`${Constantes.RUTA_API}/obtener_marcaDia.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });

            if(res[0] === 'ok'){
                this.setState({
                    notificaciones: null,
                    errores: null,
                    marcasDía: res[1],
                    consultaReingreso: true,
                });
                //}
            }
            this.setState({
                loading: false,
            })
        }else if((this.state.movimientos.codigo === '69')){
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify(this.state.movimientos);
            const control = await fetch(`${Constantes.RUTA_API}/obtener_marcaDia.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });

            if(res[0] === 'ok'){
                this.setState({
                    notificaciones: null,
                    errores: null,
                    marcasDía: res[1],
                    consultaMarcaDia: false,
                    consultaMediaHora: true,
                });
                //}
            }
            this.setState({
                loading: false,
            })
        }else if((this.state.movimientos.codigo === '76')){
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.movimientos]);
            //Voy a probar hacer los controles en la logica

            const control = await fetch(`${Constantes.RUTA_API}/guardar_licenciaEspecial.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });
            if(res === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    errores: null,
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
                });
                //}
            }
            this.setState({
                loading: false,
            })
        }else{
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.movimientos, 0]);
            //Voy a probar hacer los controles en la logica

            const control = await fetch(`${Constantes.RUTA_API}/contrlar_movimiento.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });

            //-----------------------------------------------------------------
            if(res === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    errores: null,
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
                });
                //}
            }
            this.setState({
                loading: false,
            })
            //------------------------------------------------------------------------
        }
    }

    manejarCambioNumFun(e){
        /*e.preventDefault();
        let valor = e.target.value;
        this.setState({
            numeroFuncionarioBusqueda: valor,
        });*/
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    manejarEdicion(dato){
        this.setState({
            modalActualizar: true,
            movEditar: dato,
            notificaciones: null,
        });
        this.setState(state => {
            const movEditarActualizado = state.movEditar;

            movEditarActualizado['diasAnterior'] = movEditarActualizado.dias;
            movEditarActualizado['minutosAnterior'] = movEditarActualizado.minutos;
            return {
                movEditar: movEditarActualizado,
            }
        })
    }

    manejarCambioEditar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movEditarActualizado = state.movEditar;

            movEditarActualizado[clave] = valor;
            return {
                movEditar: movEditarActualizado,
            }
        })
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.movEditar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/editar_movimiento.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            modalActualizar: false,
        });
        if(exito === 'ok'){
            this.setState({
                notificaciones: 'Los datos fueron ingresados correctamente',
                modalActualizar: false,
                errores: null,
            });
        }else{
            this.setState(state => {
                const movEditarActualizado = state.movEditar;
    
                movEditarActualizado['dias'] = movEditarActualizado.diasAnterior;
                movEditarActualizado['minutos'] = movEditarActualizado.minutosAnterior;
                return {
                    movEditar: movEditarActualizado,
                }
            })
        }
    }

    manejarBorrar(dato){
        this.setState({
            modalBorrar: true,
            movEditar: dato,
            notificaciones: null,
        });
    }

    async obtenerCal(e){
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_movimientos.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            movimientosFuncionario: exito,
        });
    } 

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            movimientosFuncionario: [],
            errores: null,
            notificaciones: null,
            movimientos: {
                idInformes: '',
                numeroFuncionario: '',
                codigo: '',
                codigoMarcaM: '',
                codigoOmision: '',
                marcaOmitida: '',
                nombreFuncionario: '',
                dias: '0',
                minutos: '0',
                desde: '',
                hasta: '',
                anio: '',
                tipoMov: '1',
                tipoHS: '',
                tipoConsulta: '',
                notasGenerales: '',
            },

            consultaMarcaDia: false,
            consultaMediaHora: false,
            consultaReingreso: false,

            marcasDía: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
                marca7: '',
                marca8: '',
                marca9: '',
                marca10: '',
                marca11: '',
                marca12: '',
                cantMarcas: '',
            },

            movEditar: {
                idMovimiento: '',
                codigo: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                diasAnterior: '',
                minutosAnterior: '',
                dias: '',
                minutos: '',
                desde: '',
                hasta: '',
                anio: '',
            },

            busqueda: {
                numeroFuncionarioBusqueda: '',
                desdeBusqueda: '',
            },
        });
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.movEditar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_movimiento.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito){
            let contador = 0;
            const arr = this.state.movimientosFuncionario;
            arr.map((name) => {
                if(this.state.movEditar.idMovimiento === name.idMovimiento){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrar: false,
                movimientosFuncionario: arr,
            });
        }
    }


    cerrarModal(e){
        e.preventDefault();
        this.obtenerCal();
        this.setState({
            modalActualizar: false,
            modalBorrar: false,
        });
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
            consultaMarcaDia: false,
            consultaMediaHora: false,
            consultaReingreso: false,
            marcasManual: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
                marca7: '',
                marca8: '',
            },
            marcasDía: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                marca1: '',
                marca2: '',
                marca3: '',
                marca4: '',
                marca5: '',
                marca6: '',
                marca7: '',
                marca8: '',
                marca9: '',
                marca10: '',
                marca11: '',
                marca12: '',
                cantMarcas: '',
            },
        });
        const clave = e.target.id;
        let valor = e.target.value;
        /*if(clave === 'codigo'){
            let val = parseFloat(valor);
            if(val == 28 || val == 46){
                this.setState({
                    ingresoDias: false,
                    ingresoMinutos: true,
                }); 
            }else{
                this.setState({
                    ingresoDias: true,
                    ingresoMinutos: false,
                }); 
            }
        }*/
        this.setState(state => {
            const movimientosActualizado = state.movimientos;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    movimientosActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    movimientosActualizado['nombreFuncionario'] = '';
                }
                });
            }
            movimientosActualizado[clave] = valor;
            return{
                movimientos: movimientosActualizado,
            };
        })
    }

    manejarCambiosMarcaManual(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
        });

        const clave = e.target.id;
        let valor = e.target.value;

        this.setState(state => {
            const marcasActualizado = state.marcasManual;

            marcasActualizado[clave] = valor;
            return{
                marcasManual: marcasActualizado,
            };
        })
    }

    async manejarEnviarMarcaManual(e){
        e.preventDefault();
        if((this.state.marcasManual.marca1 === '')){
            this.setState({
                errores: 'La Marca1, Marca2 y Marca3 no pueden ser vacias',
            })
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify([this.state.marcasManual, this.state.movimientos, this.state.marcasDía]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_marcaManual.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito === 'ok'){
                this.setState({
                    notificaciones: 'Las marcas fueron ingresadas correctamente',
                    errores: null,
                    consultaMarcaDia: false,
                    consultaMediaHora: false,
                    consultaReingreso: false,
                    consulta: false,
                    marcasDía: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                        marca9: '',
                        marca10: '',
                        marca11: '',
                        marca12: '',
                        cantMarcas: '',
                    },
        
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
        
                    marcasManual: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                    },
                })
            }
        }
    }

    async manejarEnvioReingreso(e){
        e.preventDefault();
        if((this.state.marcasManual.marca1 === '')){
            this.setState({
                errores: 'Debe indicar que marca es la de reingreso',
            })
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify([this.state.marcasManual, this.state.movimientos]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_marcaReingreso.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito === 'ok'){
                this.setState({
                    notificaciones: 'Las marca fue ingresada correctamente',
                    errores: null,
                    consultaMarcaDia: false,
                    consultaMediaHora: false,
                    consultaReingreso: false,
                    consulta: false,
                    marcasDía: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                        marca9: '',
                        marca10: '',
                        marca11: '',
                        marca12: '',
                        cantMarcas: '',
                    },
        
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
        
                    marcasManual: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                    },
                })
            }
        }
    }

    async manejarEnvioMediaHora(e){
        e.preventDefault();
        if((this.state.marcasManual.marca1 === '') || (this.state.marcasManual.marca2 === '')){
            this.setState({
                errores: 'La Marca1y Marca2 no pueden ser vacias',
            })
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify([this.state.marcasManual, this.state.movimientos, this.state.marcasDía]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_marcaMediaHora.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                errores: exito,
            })

            if(exito === 'ok'){
                this.setState({
                    notificaciones: 'Las marcas fueron ingresadas correctamente',
                    errores: null,
                    consultaMarcaDia: false,
                    consultaMediaHora: false,
                    consultaReingreso: false,
                    consulta: false,
                    marcasDía: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                        marca9: '',
                        marca10: '',
                        marca11: '',
                        marca12: '',
                        cantMarcas: '',
                    },
        
                    movimientos: {
                        idInformes: '',
                        numeroFuncionario: '',
                        codigo: '',
                        codigoMarcaM: '',
                        codigoOmision: '',
                        marcaOmitida: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        desde: '',
                        hasta: '',
                        anio: '',
                        tipoMov: '1',
                        tipoHS: '',
                        tipoConsulta: '',
                        notasGenerales: '',
                    },
        
                    marcasManual: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        marca1: '',
                        marca2: '',
                        marca3: '',
                        marca4: '',
                        marca5: '',
                        marca6: '',
                        marca7: '',
                        marca8: '',
                    },
                })
            }
        }
    }

    manejarConsultaInforme(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: true,
            datoEspecifico: dato,
        })
    }

    manejarAtrasEspecifica(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: false,
            datoEspecifico: {},
        })
    }
}

export default DatosMovimiento